import React, { useState, useEffect, useContext } from 'react';
import {AiOutlineCheck, AiOutlineClose, AiOutlineCoffee} from 'react-icons/ai';
import {IoIosInfinite} from 'react-icons/io';

import Button from '../../../components/Button';
import Switch from '../../../components/Switch';
import appContext from '../../../redux/contexts/appContext'

function Vote({c, onVote, members, votes, type, cards}) {

  const [complexity, setComplexity] = useState(0);
  const [effort, setEffort] = useState(0);
  const [poker, setPoker] = useState(-1);
  const [coffee, setCoffee] = useState(false);
  const [isVoteAvailable, setVoteAvailable] = useState(false);

  const {state, dispatch} = useContext(appContext);

  const handleVote = (values, c = coffee) => {
    if (!checkIfCanVote()) {
      return false;
    }

    if (type === 1) {
      
      onVote(values, c);
      setVoteAvailable(false);
    }
    else if (type === 2) {
      onVote(values, c);
      setVoteAvailable(false);
    }
    
  }

  const checkIfCanVote = () => {

    if (!state || !state.user || !state.user.id) return false;

    var userId = state.user.id 
    var member = members.find(m => m.id == userId);
    if ((member && (member.voted === false || 1==1)) ) {
      setVoteAvailable(true);
      return true;
    }
    return false;
  }


  const changeComplexity = (to) => {
    if (checkIfCanVote()) {
      handleVote({
        poker: poker,
        complexity: to,
        effort: effort
      }, coffee);
      setComplexity(to);

    }
  }
  const changeEffort = (to) => {
    if (checkIfCanVote()) {
      handleVote({
        poker: poker,
        complexity: complexity,
        effort: to
      }, coffee);
      setEffort(to);

    }
  }

  useEffect(() => {
    checkIfCanVote();
  }, [members, effort, complexity])

  useEffect(() => {
    var userVote = votes.find(v => v.userid === state.user.id);
    if (userVote) {
      setEffort(userVote?.value?.effort || 0);
      setComplexity(userVote?.value?.complexity || 0);
      setPoker(userVote?.value?.poker || -1);
      setCoffee(userVote?.coffee || false);
    }
  }, [votes])

  return (
  <div className={c.voting}>
    <div className={c.coffeeBreakOption}>
      <span>Coffee Break</span>
      <Switch onChange={e => {
        setCoffee(e);
        handleVote({
          poker: poker,
          complexity: complexity,
          effort: effort
        }, e);
        
      }} value={coffee}></Switch>
    </div>
    
    {type === 1 && (
      <div className={c.pokerContainer}>
        {cards?.map(card => {
          return <div className={c.pokerCard + " " + (poker === (parseInt(card) == card ? parseInt(card) : card) ? "selected" : "")}  onClick={() => {
            setPoker(parseInt(card) == card ? parseInt(card) : card)
            var values = {
              poker: parseInt(card) == card ? parseInt(card) : card
            };
            handleVote(values, coffee)
          }}>
            {card.toString().toUpperCase() == "INFINITE" ? 
            <IoIosInfinite/>
            :
            card
            }
          </div>
        })}

      </div>
    )} 

    {type === 2 && (
      <>
        <div className={c.vrow}>
          <span>Complexity</span>
          <div className={c.vcards}>
            <div className={c.vcard + " " + (complexity === 1 ? "selected" : "")} onClick={() => changeComplexity(1)}>1</div>
            <div className={c.vcard + " " + (complexity === 2 ? "selected" : "")} onClick={() => changeComplexity(2)}>2</div>
            <div className={c.vcard + " " + (complexity === 3 ? "selected" : "")} onClick={() => changeComplexity(3)}>3</div>
            <div className={c.vcard + " " + (complexity === 4 ? "selected" : "")} onClick={() => changeComplexity(4)}>4</div>
            <div className={c.vcard + " " + (complexity === 5 ? "selected" : "")} onClick={() => changeComplexity(5)}>5</div>
          </div>
        </div>
        <div className={c.vrow} >
          <span>Effort</span>
          <div className={c.vcards}>
            <div className={c.vcard + " " + (effort === 1 ? "selected" : "")} onClick={() => changeEffort(1)}>1</div>
            <div className={c.vcard + " " + (effort === 2 ? "selected" : "")} onClick={() => changeEffort(2)}>2</div>
            <div className={c.vcard + " " + (effort === 3 ? "selected" : "")} onClick={() => changeEffort(3)}>3</div>
            <div className={c.vcard + " " + (effort === 4 ? "selected" : "")} onClick={() => changeEffort(4)}>4</div>
            <div className={c.vcard + " " + (effort === 5 ? "selected" : "")} onClick={() => changeEffort(5)}>5</div>
          </div>
        </div>
      </>
    )}
    
    

    {/* <div className={c.btna}>
      {isVoteAvailable && (
       <Button disabled={!isVoteAvailable} className={c.votebtn}>Vote</Button>
      )}
    </div> */}
  </div>
  );
}

export default Vote;